import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

/** Full-bleed image band with a scroll-linked parallax image layer. */
export default function ParallaxSection({ image, className = "", children, height, strength = 14 }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${strength}%`, `${strength}%`]);

  return (
    <section ref={ref} className={`parallax-section ${className}`} style={height ? { minHeight: height } : undefined}>
      <motion.div className="parallax-img" style={{ backgroundImage: `url(${image})`, y }} aria-hidden="true" />
      <div className="parallax-overlay" aria-hidden="true" />
      <div className="parallax-content">{children}</div>
    </section>
  );
}
